import React, { forwardRef } from 'react';
import { classNames } from '@panwds/tailwindcss';
const iconSizeVariants = {
    xxs: 'tw-h-2',
    xs: 'tw-h-3',
    sm: 'tw-h-3.5',
    md: 'tw-h-4',
    lg: 'tw-h-5',
    xl: 'tw-h-6',
    xxl: 'tw-h-7',
    '3xl': 'tw-h-8',
    '4xl': 'tw-h-10',
    '5xl': 'tw-h-12'
};
/**
 * An img-element icon. In general, prefer the Font Awesome icons. In the cases where we need an icon not provided by Font Awesome, this component can be used.
 */
export const ImgIcon = forwardRef(({ addClassName, size = 'md', ...passThrough }, ref) => {
    const classes = classNames('tw-inline-block tw-overflow-visible tw-align-middle', iconSizeVariants[size], addClassName);
    return React.createElement("img", { ...passThrough, className: classes, ref: ref });
});
ImgIcon.displayName = 'ImgIcon';
//# sourceMappingURL=ImgIcon.js.map